var map = {
	"./pistol.wav": 8015,
	"./sandao1.wav": 313,
	"./sandao2.wav": 8926,
	"./sandao3.wav": 983,
	"./shuffle_cards.wav": 7001,
	"./一对.wav": 9931,
	"./一条龙.wav": 1196,
	"./三同花.wav": 7386,
	"./三条.wav": 9968,
	"./三顺子.wav": 7169,
	"./两对.wav": 7479,
	"./乌龙.wav": 2815,
	"./五同.wav": 2850,
	"./倒水.wav": 2932,
	"./全垒打.wav": 5387,
	"./六对半.wav": 8970,
	"./同花.wav": 1799,
	"./同花顺.wav": 4895,
	"./开始比牌.wav": 2485,
	"./打枪.wav": 3281,
	"./散牌.wav": 2307,
	"./相公.wav": 1126,
	"./葫芦.wav": 4821,
	"./铁支.wav": 658,
	"./顺子.wav": 7384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4558;